import React, { Component } from 'react';


class Resume extends Component {
  render() {
    if(this.props.data){
      var skillmessage = this.props.data.skillmessage;
      var employment = this.props.data.employment.map(function(employment){
        return <div key = {employment.title}><h1>{employment.title}</h1>
              <p>{employment.course} &bull; {employment.date}
              </p>
        </div>
      })

      var education = this.props.data.education.map(function(education){
        return <div>
          <div key={education.degree}><h1>{education.degree}</h1>
          <p className="info">{education.school}<span>&bull;</span><em className="date">{education.graduated}</em></p>
          {/* <p>This is url: <a href={"https://www.w3schools.com"}>{education.title}</a></p> */}
          </div>
          <p>{education.advisors !== undefined?
          (education.advisor2 !== undefined?
          "Advisors: Prof. "
          :"Advisor: Prof. "
          )
          :undefined
          }
          <a href = {education.advisorUrl} target = "_blank"> {education.advisors}</a>
          {education.advisor2 !== undefined?
          " and Prof. "
          :undefined
          }
          <a href = {education.advisorUrl2} target = "_blank"> {education.advisor2}</a><br />
          {education.description !== undefined?
          "Thesis:"
          : undefined
          }
          <a href = {education.url} target = "_blank"> {education.description}</a>
          </p>
          {/* {education.description}</p> */}
          </div>
      })

      var research = this.props.data.research.map(function(research){
        return <div key={research.company}><a href={research.url} target = "_blank"><h1>{research.company}</h1></a>
            <div>
              {research.authors}
              <p className="info">{research.publisher}<span>&bull;</span> <em className="date">{research.years}</em></p>
              <a href={research.errata_url} target = "_blank">{research.errata}</a>
              <p>{research.description}</p>
            </div>
        </div>
      })

      var preprints = this.props.data.preprints.map(function(preprints){
        return <div key={preprints.company}><a href={preprints.url} target = "_blank"><h1>{preprints.company}</h1></a>
            <div>
              {preprints.authors}
              <p className="info">{preprints.publisher}<span>&bull;</span> <em className="date">{preprints.years}</em></p>
              <p>{preprints.description}</p>
            </div>
        </div>
      })

      var awards = this.props.data.awards.map(function(awards){
        return <div key = {awards.title}>
              <a href={awards.url} target = "_blank"><h1>{awards.title}</h1></a>
              <p><a href={awards.url}></a> {awards.location} &bull; {awards.date}</p>
        </div>
      })

      var talks = this.props.data.talks.map(function(talks){
        return <div key = {talks.title}>
              <a href={talks.url} target = "_blank"><h1>{talks.title}</h1></a>
              <p><a href={talks.url}></a> {talks.location} &bull; {talks.date}</p>
        </div>
      })

      var present = this.props.data.present.map(function(present){
        return <div key = {present.title}>
              <a href={present.url} target = "_blank"><h1>{present.title}</h1></a>
              <p><a href={present.url}></a> {present.location} &bull; {present.date}</p>
        </div>
      })

      var organize = this.props.data.organize.map(function(organize){
        return <div key={organize.company}><a href={organize.url} target = "_blank"><h1>{organize.company}</h1></a>
            <div>
              {organize.authors}
              <p className="info">{organize.publisher}<span>&bull;</span> <em className="date">{organize.years}</em></p>
              <p>{organize.description}</p>
            </div>
        </div>
      })

      var skills = this.props.data.skills.map(function(skills){
        var className = 'bar-expand '+skills.name.toLowerCase();
        return <li key={skills.name}><span style={{width:skills.level}}className={className}></span><em>{skills.name}</em></li>
      })

      var teaching = this.props.data.teaching.map(function(teaching){
        return <div key = {teaching.title}><h1>{teaching.title}</h1>
              <p>{teaching.course} &bull; {teaching.date}
              </p>
        </div>
      })
    }

    return (
    <section id="resume">

    <div className="row education">
      <div className="three columns header-col">
        <h1><span>Appointments</span></h1>
      </div>

      <div className="nine columns main-col">
        {employment}
      </div>
    </div>

    <div className="row education">
      <div className="three columns header-col">
        <h1><span>Education and Training</span></h1>
      </div>

      <div className="nine columns main-col">
        {education}
        <a class="anchor" id="research"></a>
      </div>
    </div>

    <div className="row education">
      <div className="three columns header-col">
        <h1><span>Research Interests</span></h1>
      </div>

      <div className="nine columns main-col">
      My research lies at the intersection of nonlinear partial differential equations, fluid dynamics, mathematical biology, and data-driven modeling. 
      I am particularly interested in well-posedness, stability and long-time behavior, boundary and interface effects, concentration and singularity formation, and the learning of governing laws from data. 
      Models and problems I have studied include: 
      <br/>
      1. Navier–Stokes and Stokes systems, particularly in domains with boundaries; <br/>
      2. free-boundary models for gas bubbles in liquids, including surface tension, thermal effects, interface deformation, and rotating equilibria; <br/>
      3. deterministic and stochastic chemotaxis–fluid systems, including Patlak–Keller–Segel–Navier–Stokes models; <br/>
      4. nematic liquid crystal flows; <br/>
      5. magnetohydrodynamic and viscoelastic fluid systems; <br/>
      6. generalized diffusion and Fokker–Planck equations with non-gradient drift structures; <br/>
      7. porous-medium-type models of tissue and tumor growth;  <br/>
      8. reaction–diffusion systems, including Lotka–Volterra models; and<br/>
      9. concentration and blow-up phenomena in nonlinear parabolic equations. <br/>
      </div>
    </div>
   

    <div className="row education">
      <div className="three columns header-col">
        <h1><span>Publications</span></h1>
      </div>

      <div className="nine columns main-col">
        {research}
      </div>
    </div>

    <div className="row education">
      <div className="three columns header-col">
        <h1><span>Preprints</span></h1>
      </div>

      <div className="nine columns main-col">
        {preprints}
      </div>
    </div>
    
    <div className="row education">
      <div className="three columns header-col">
        <h1><span>Awards</span></h1>
      </div>

      <div className="nine columns main-col">
        {awards}
      </div>
    </div>

    <div className="row education">
      <div className="three columns header-col">
        <h1><span>Conference/Workshop Presentations</span></h1>
      </div>

      <div className="nine columns main-col">
        {talks}
      </div>
    </div>

    <div className="row education">
      <div className="three columns header-col">
        <h1><span>Seminar/Colloquium Presentations</span></h1>
      </div>

      <div className="nine columns main-col">
        {present}
      </div>
    </div>


    <div className="row education">
      <div className="three columns header-col">
        <h1><span>Conference/Workshop (Co)-Organization</span></h1>
      </div>

      <div className="nine columns main-col">
        {organize}
      </div>
    </div>

    <div className="row research">
      <div className="three columns header-col">
        <h1><span>Teaching</span></h1>
      </div>

      <div className="nine columns main-col">
        {teaching}
      </div>
    </div>

   </section>
    );
  }
}

export default Resume;
